export default __webpack_public_path__ + "static/media/lora_s.358c8ca2.jpg";